
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Hybrid Code Examples`}</h3>
    <ul>
      <li parentName="ul">{`The `}<a parentName="li" {...{
          "href": "/patterns/lists"
        }}>{`List`}</a>{` patterns have added examples for Multiselect List and Sortable List.`}</li>
      <li parentName="ul">{`The `}<a parentName="li" {...{
          "href": "/patterns/appbar"
        }}>{`App Bars`}</a>{` patterns have added examples for Collapsible Appbar and Search Bar.`}</li>
    </ul>
    <h3>{`Component Library`}</h3>
    <p>{`We have been continuing to develop new components to build out our component library.`}</p>
    <ul>
      <li parentName="ul">{`For React Native, we have added components for `}<a parentName="li" {...{
          "href": "https://github.com/pxblue/react-native-component-library/blob/dev/docs/Header.md"
        }}>{`Header`}</a>{`, `}<a parentName="li" {...{
          "href": "https://github.com/pxblue/react-native-component-library/blob/dev/docs/InfoListItem.md"
        }}>{`InfoListItem`}</a>{`, and `}<a parentName="li" {...{
          "href": "https://github.com/pxblue/react-native-component-library/blob/dev/docs/ScoreCard.md"
        }}>{`ScoreCard`}</a>{`.`}</li>
      <li parentName="ul">{`For React, we have added components for `}<a parentName="li" {...{
          "href": "https://github.com/pxblue/react-component-library/blob/dev/docs/InfoListItem.md"
        }}>{`InfoListItem`}</a>{` and `}<a parentName="li" {...{
          "href": "https://github.com/pxblue/react-component-library/blob/dev/docs/ScoreCard.md"
        }}>{`ScoreCard`}</a>{`.`}</li>
    </ul>
    <h3>{`Moving to TypeScript`}</h3>
    <p>{`To take advantage of it's many benefits, new resources for React and React Native will be built using Typescript instead of plain JavaScript. We have also begun the process of migrating our existing resources to TypeScript.`}</p>
    <h3>{`Miscellaneous`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes and improvements`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;